import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import * as CryptoJS from 'crypto-js'
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from 'src/app/services/userService/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cowatch',
  templateUrl: './cowatch.component.html',
  styleUrls: ['./cowatch.component.less']
})
export class CowatchComponent {
  coWatchState = "login";
  coWatchViewType = "co-default";
  coWatchStyle = {
    width: "30%",
    height: "500px",
  }

  @Output() onClose = new EventEmitter();
  @ViewChild('coWatch') coWatch: ElementRef;
  @ViewChild('coWatchFrame') coWatchFrame: ElementRef;

  constructor(private userService: UserService, private deviceService: DeviceDetectorService) { }

  ngAfterViewInit(): void {
    this.coWatchFrame.nativeElement.setAttribute('src', environment.coWatchENV + "/jwt?token=" + this.getCoWatchToken() + "&lang=" + this.userService.getLanguageService().getLanguage());
  }

  // Messages listener to listen co watch current state
  @HostListener('window:message', ['$event']) onMessage(event) {
    if (event && event.data && event.data.message) {
      if (event.data.message == "meeting") {
        if (this.coWatchViewType == "co-default") {
          this.coWatchViewType = "co-square";
        }
        this.coWatchState = event.data.message;
      } else {
        this.coWatchViewType = "co-default";
        this.coWatchState = event.data.message;
      }
    }
  }

  // Close button action
  closeCoWatch() {
    this.onClose.emit();
  }

  // Change view of the co watch frame
  changeView(viewType) {
    this.coWatchViewType = viewType;
    switch (viewType) {
      case "co-square":
        this.coWatchStyle = {
          width: "40vw",
          height: "26.5vw",
        }
        break;
      case "co-vert":
        this.coWatchStyle = {
          width: "25vw",
          height: "82vh",
        }
        break;
      case "co-row":
        this.coWatchStyle = {
          width: "50vw",
          height: "30.5 %",
        }
        break;
    }
  }

  // Get JWT for authenticate cowatc
  getCoWatchToken() {
    // Header
    let header = {
      "alg": "HS256"
    };

    let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    let encodedHeader = this.base64url(stringifiedHeader);

    // Data
    let browserData = this.deviceService.getDeviceInfo();
    let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify({
      "subscriberId": "sub" + this.userService.getUser().id,
      "profileId": this.userService.getUser().id,
      "deviceType": browserData.browser + " " + browserData.browser_version,
      "language": this.userService.getLanguageService().getLanguage(),
      "iss": "ARXNET",
      "iat": moment().unix(),
      "exp": moment().add(1, 'hour').unix(),
      "aud": "cytacowatch",
    }));
    let encodedData = this.base64url(stringifiedData);
    let token = encodedHeader + "." + encodedData;

    // Sign with secret key
    let secret = "UH1nh5ftET97KoTWTlPJNc5FEboRyh0t";
    let signature = CryptoJS.HmacSHA256(token, secret);
    signature = this.base64url(signature);
    let signedToken = token + "." + signature;

    return signedToken;
  }

  // Function Used to generate JWT
  base64url(source) {
    // Encode in classical base64
    let encodedSource = CryptoJS.enc.Base64.stringify(source);

    // Remove padding equal characters
    encodedSource = encodedSource.replace(/=+$/, '');

    // Replace characters according to base64url specifications
    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');

    return encodedSource;
  }
}